import { render, staticRenderFns } from "./WebstarsIndex.vue?vue&type=template&id=6d8a5939&"
import script from "./WebstarsIndex.vue?vue&type=script&lang=js&"
export * from "./WebstarsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports